import { PsHttpService, type PatSnapCommonResponseData } from '@patsnap/tahiti-core/common/ps-http';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { ExecuteShareTaskResponse } from '../../types';
import type { DuplicateExecuteApi } from '../duplicate-execute-api';

@injectable()
export class DuplicateExecuteApiImpl extends PsHttpService implements DuplicateExecuteApi {
    get options() {
        return {
            baseURL: `${import.meta.env.VITE_EUREKA_SERVICE_URI}/eureka`,
            agentBaseURL: `${import.meta.env.VITE_EUREKA_SERVICE_URI}/api/eureka`,
            headers: {
                'X-API-Version': '1.0',
            },
        };
    }

    executeShareTask(group_id: string) {
        return this.get<PatSnapCommonResponseData<ExecuteShareTaskResponse>>({
            url: `/secure-share/copy-task/${group_id}/status`,
        }).then((res) => {
            return res.data as ExecuteShareTaskResponse;
        });
    }

    executeShareTaskAgent(source_id: string, target_id: string) {
        return this.post<PatSnapCommonResponseData<string>>({
            url: `${this.options.agentBaseURL}/copy-session-data`,
            data: {
                source_session_id: source_id,
                target_session_id: target_id,
            },
        }).then((res) => {
            return res.data as string;
        });
    }
}
